import React, { Component } from 'react';
import PropTypes from 'prop-types';

// Components
import {
    IconButton,
    OutlinedInput,
    InputLabel,
    InputAdornment,
    FormHelperText,
    FormControl,
    Tooltip
} from '@material-ui/core';
import VpnKeyOutlined from '@material-ui/icons/VpnKeyOutlined';

// css
import { withStyles } from '@material-ui/core';
const styles = theme => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    withoutLabel: {
        marginTop: theme.spacing(3),
    },
    textField: {
        minWidth: '100%',
    },
});



class FormFieldPK extends Component {

    render() {
        const { classes, value, helperText, genPK } = this.props;

        return (
            <FormControl className={classes.textField}
                variant="outlined"
                size="small"
                error={helperText !== '' ? true : false}
            >
                <InputLabel htmlFor="outlined-adornment-password">Product Key</InputLabel>
                <OutlinedInput
                    value={value}
                    readOnly
                    endAdornment={
                        <InputAdornment position="end">
                            <IconButton
                                onClick={genPK}
                                size="small"
                                edge="end"
                            >
                                <Tooltip title="Genera" >
                                    <VpnKeyOutlined />
                                </Tooltip>
                            </IconButton>
                        </InputAdornment>
                    }
                    labelWidth={90}
                />
                {helperText !== '' ? <FormHelperText id="outlined-weight-helper-text">{helperText}</FormHelperText> : null}
            </FormControl>
        );
    }
}

FormFieldPK.propTypes = {
    genPK: PropTypes.func.isRequired,

    value: PropTypes.string.isRequired,
    helperText: PropTypes.string.isRequired,
};

export default withStyles(styles)(FormFieldPK);